import { Link } from 'react-router-dom';
import { TableName } from 'src/modules/Catalog/pages/Products/components/TableName/tableName';

const tableName = (
  <TableName
    label="Nome"
    tooltip="Nome que o lojista visualizará na sua loja da inventa"
  />
);

const renderProductName = ({ row, productName }) => {
  const productRowTitle =
    row.title === 'Default Title' ? productName : row.title;

  const title = row.title ? productRowTitle : '-';

  return (
    <Link
      className="text-dark text-decoration-none p-1"
      to={`/product/${row.product_id}/variant/${row.id}`}
    >
      <span>{title}</span>
    </Link>
  );
};

const getProductNameColumn = productName => ({
  name: tableName,
  cell: row => renderProductName({ row, productName }),
  sortable: true,
  grow: 4,
  fontWeight: 'bold',
});

export default getProductNameColumn;
